import { render, staticRenderFns } from "./FormCustomAttachmentField.vue?vue&type=template&id=0e2f050b&scoped=true&"
import script from "./FormCustomAttachmentField.vue?vue&type=script&lang=js&"
export * from "./FormCustomAttachmentField.vue?vue&type=script&lang=js&"
import style0 from "./FormCustomAttachmentField.vue?vue&type=style&index=0&id=0e2f050b&prod&lang=scss&scoped=true&"
import style1 from "./FormCustomAttachmentField.vue?vue&type=style&index=1&id=0e2f050b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2f050b",
  null
  
)

export default component.exports